const clickoutside = {
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 這裡判斷點選的元素是否是本身，是本身，則返回
      if (el.contains(e.target)) {
        return false
      }
      // 判斷指令中是否繫結了函式
      if (binding.expression) {
        binding.value(e)
      }
    }
    // 給目前元素繫結個私有變數，方便在unbind中可以解除事件監聽
    el.__vueClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler)
  },
  unbind(el, binding) {
    // 解除事件監聽
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}
export default clickoutside
